import React, { useEffect, useState } from "react";
import { Route, Navigate } from "react-router-dom";
import { getCookie } from "cookies-next";
import { TOKEN } from "./localStorage";
import { useSelector } from "react-redux";

const hasPermission = (userPermissions, screenName) => {
  const permission = userPermissions?.find(
    (permission) =>
      permission?.screen?.name === screenName && permission?.screen?.active
  );

  if (permission?.active) {
    if (permission) {
      return true
    } else {
      return false
    }
  } else {
    return false
  }
};

const ProtectedRoute = ({ Component, value }) => {
  const tokan = getCookie(TOKEN);
  console.log(tokan);
  const userData = useSelector((state) => state?.user?.userData);
  useEffect(() => { }, []);
  return tokan != null ? value ? userData?.role?.name  === "COMPANY_ADMIN" ? <Component /> : hasPermission(userData?.userRolePermission, value) ? <Component /> : <Navigate to="/dashboard" /> : <Component /> : <Navigate to="/" />;
};
export default ProtectedRoute;
